import React from 'react';
import { Hero } from '../components/home/Hero';
import { CommitmentsSection } from '../components/home/CommitmentsSection';
import { ServicesSection } from '../components/home/ServicesSection';
import { SeasonsSection } from '../components/home/SeasonsSection';
import { PlansSection } from '../components/home/PlansSection';
import { GallerySection } from '../components/home/GallerySection';
import { ProcessSection } from '../components/home/ProcessSection';
import { AreaSection } from '../components/home/AreaSection';
import { FaqSection } from '../components/home/FaqSection';
import { QuoteSection } from '../components/home/QuoteSection';
export function Home() {
  return <>
      <Hero data-id="element-235" data-mp="2di8crjwpabm4" />
      <CommitmentsSection data-id="element-236" data-mp="2dirup0mcp005" />
      <ServicesSection data-id="element-237" data-mp="2dj9wecrs86fg" />
      <SeasonsSection data-id="element-238" data-mp="2dfdt3uligutr" />
      <PlansSection data-id="element-239" data-mp="3kvtljevwhrxy" />
      <GallerySection data-id="element-240" data-mp="3ku8rrrheud15" />
      <ProcessSection data-id="element-241" data-mp="3kuqyxj5m2bnu" />
      <AreaSection data-id="element-242" data-mp="3kxmsywec8g70" />
      <FaqSection data-id="element-243" data-mp="3owlxifw5qaxx" />
      <QuoteSection data-id="element-244" data-mp="3ow421lhbk0r2" />
    </>;
}